// This file is generated by api-generator.mjs, please do not modify it manually.

import { API_ENDPOINT, REQUEST_ORIGIN, UserRoleLevelEnum } from "@/constant/common";
import qs from "qs";
import fetchBackend from "./request";


export const getRecommendAuthorList = async (params: AUTHOR_API.GetRecommendAuthorListRequest, options?: RequestOptions): Promise<AUTHOR_API.GetRecommendAuthorListReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}authors?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getAuthorBlogList = async (params: AUTHOR_API.GetAuthorBlogListRequest, options?: RequestOptions): Promise<AUTHOR_API.GetAuthorBlogListReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}authors/blogs?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getAuthor = async (params: AUTHOR_API.GetAuthorRequest, options?: RequestOptions): Promise<AUTHOR_API.GetAuthorReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}authors/${params.author_id}?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

